// Read hooks for CES (Compliance Evaluation Sheet) rows.
//
// `useCesRows` returns the flat list; `useCesRowsByRef` returns the rows grouped
// by transaction `referenceNo` (each group sorted by `seq`) — the shape working
// -paper and register surfaces consume. Errors are surfaced, not swallowed.
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchCesRows, fetchCesRowsByRef } from '../lib/db';

export function useCesRows() {
  return useQuery({
    queryKey: queryKeys.cesRows,
    queryFn: fetchCesRows,
  });
}

/**
 * All CES rows grouped by transaction `referenceNo` (each sorted by `seq`).
 * `enabled` (default true) lets a caller defer the (large) fetch — e.g. the
 * Transactions register only needs CES for the export-capable roles.
 */
export function useCesRowsByRef(enabled = true) {
  return useQuery({
    queryKey: queryKeys.cesRowsByRef,
    queryFn: fetchCesRowsByRef,
    enabled,
  });
}
